module.exports = __webpack_public_path__ + "img/RTB-Silo-front.fcf4311a.png";